<template>
  <nx-tabs v-if="tabs.length > 0"
           :value="tab"
           :tabs="tabs"
           @input="changeTab"
           color="transparent">
  </nx-tabs>
</template>

<script>
import NxTabs from '@/components/Tabs';

export default {
  name: 'nx-entity-editor-tabs',
  components: {
    NxTabs,
  },
  props: {
    tab: {
      type: String,
      required: true,
    },
  },
  computed: {
    tabs() {
      return [
        { id: 'editor', label: this.$t('message.entity.editor.tab.editor') },
        { id: 'treeView', label: this.$t('message.entity.editor.tab.treeView') },
      ];
    },
  },
  methods: {
    changeTab(tab) {
      this.$emit('changeTab', tab);
    },
  },
};
</script>
